/**
 * @desc selectPonoStock
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.StockOccupyMasterResponseRpcDto>>;
export function request(
  body: defs.tms.StockOccupyMasterSelectRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupy/selectPonoStock`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
